// src/utils/carte.js
import { i18n } from '@/i18n';

// La carte dort-elle ? Miroir de `isSleepProne` (backend/services/mqtt.service.js) : batterie
// seule, ou mode éco, dort ; secteur et solaire normal restent connectés en permanence.
// Calculé ici à partir des champs poussés en temps réel (power_source, solar_mode, eco_mode),
// pour suivre un passage secteur → batterie sans recharger la page.
export function carteEndormie(device) {
  if (!device) return false;
  if (device.eco_mode) return true;
  if (device.solar_mode) return false;
  return device.power_source === 'battery';
}

// Message affiché à la place d'une action immédiate (armer, désarmer, rapport d'état, jumelage)
// quand la carte dort hors fenêtre de maintenance. Même sens que le refus du serveur
// (code CARTE_ENDORMIE) : la commande ne serait ni retenue ni rejouée.
// Texte : `carte.endormie` (locales/parts/carte.json). Fonction et non constante, pour suivre
// un changement de langue.
export const messageEndormie = () => i18n.global.t('carte.endormie');
